<template>
    <div class="d-flex-grow justify-center">
         <v-form @submit.prevent="store" ref="formRef" v-model="formValid" class="w-100 w-md-50rem max-w-100">
             <v-card class="d-flex-col-grow">
                 <v-card-text class="flex-grow-1">
                     <div class="d-flex flex-column ga-7">
                         <div class="fs-2 fw-medium">
                             Biller Information
                         </div>
                         <div v-if="form.errors.custom_error" class="fs-1 text-error">
                             {{ form.errors.custom_error }}
                         </div>
                         <div>
                                <div class="w-25rem max-w-100 border rounded-lg px-3 py-3 pb-4 bg-surface">
                                    <input
                                            ref="logoInput"
                                            type="file"
                                            class="d-none"
                                            @change="updateLogoPreview"
                                        >

                                        <!-- <InputLabel for="photo" value="Photo" /> -->

                                        <!-- Current Profile Photo -->
                                        <div v-show="! logoPreview" class="mt-2">
                                            <v-avatar rounded="0" size="150px" >
                                                <v-img :src="biller?.logo?.file_url || defaultLogo" :cover="false"></v-img>
                                            </v-avatar>
                                        </div>

                                        <!-- New Profile Photo Preview -->
                                        <div v-show="logoPreview" class="mt-2">
                                            <v-avatar rounded="0" size="150px" class="v-theme--light">
                                                <v-img :src="logoPreview ?? ''" :cover="false"></v-img>
                                            </v-avatar>
                                        </div>

                                        <div class="d-flex ga-2 mt-4 flex-wrap">
                                            <v-btn color="secondary" variant="outlined" text="Select A New Logo" class="v-theme--light" @click.prevent="selectNewLogo"></v-btn>
                                            <!-- <v-btn v-if="biller?.logo?.file_url" color="danger" variant="outlined" text="Remove Logo" class="v-theme--light" @click.prevent="deleteLogo"></v-btn> -->

                                        </div>

                                </div>
                         </div>
                         <div>
                             <v-text-field-v1
                                 label="Company name"
                                 v-model="form.name"
                                 placeholder=""
                                 :error-messages="form.errors.name"
                             ></v-text-field-v1>
                         </div>
                         <div>
                             <v-row>
                                 <v-col cols="12" sm="6">
                                     <div>
                                         <v-text-field-v1
                                             label="Email"
                                             v-model="form.email"
                                             placeholder=""
                                             :error-messages="form.errors.email"
                                         ></v-text-field-v1>
                                     </div>
                                 </v-col>
                                 <v-col cols="12" sm="6">
                                     <div>
                                         <v-text-field-v1
                                             label="Domain"
                                             v-model="form.domain"
                                             placeholder=""
                                             :error-messages="form.errors.domain"
                                         ></v-text-field-v1>
                                     </div>
                                 </v-col>
                                 <v-col cols="12">
                                     <div>
                                         <v-text-field-v1
                                             label="Street address"
                                             v-model="form.street_address"
                                             placeholder=""
                                             :error-messages="form.errors.street_address"
                                         ></v-text-field-v1>
                                     </div>
                                 </v-col>
                                 <v-col cols="12" sm="6" lg="3">
                                     <div>
                                         <v-text-field-v1
                                             label="City"
                                             v-model="form.city"
                                             placeholder=""
                                             :error-messages="form.errors.city"
                                         ></v-text-field-v1>
                                     </div>
                                 </v-col>
                                 <v-col cols="12" sm="6" lg="3">
                                     <div>
                                         <v-text-field-v1
                                             label="State"
                                             v-model="form.state"
                                             placeholder=""
                                             :error-messages="form.errors.state"
                                         ></v-text-field-v1>
                                     </div>
                                 </v-col>
                                 <v-col cols="12" sm="6" lg="3">
                                     <div>
                                         <v-text-field-v1
                                             label="Postal code"
                                             v-model="form.postal_code"
                                             placeholder=""
                                             :error-messages="form.errors.postal_code"
                                         ></v-text-field-v1>
                                     </div>
                                 </v-col>
                                 <v-col cols="12" sm="6" lg="3">
                                     <div>
                                         <v-text-field-v1
                                             label="Country"
                                             v-model="form.country"
                                             placeholder=""
                                             :error-messages="form.errors.country"
                                         ></v-text-field-v1>
                                     </div>
                                 </v-col>
                                 <v-col cols="12">
                                     <div>
                                         <v-text-field-v1
                                             label="Signwell - Template ID"
                                             v-model="form.signwell_template_id"
                                             placeholder=""
                                             :error-messages="form.errors.signwell_template_id"
                                         ></v-text-field-v1>
                                     </div>
                                 </v-col>
                                 <v-col cols="12">
                                     <div>
                                         <v-text-field-v1
                                             label="Signwell - Signor Placeholder ID"
                                             v-model="form.template_signor_placeholder_id"
                                             placeholder=""
                                             :error-messages="form.errors.template_signor_placeholder_id"
                                         ></v-text-field-v1>
                                     </div>
                                 </v-col>
                                 <v-col cols="12">
                                     <div>
                                         <v-text-field-v1
                                             label="Signwell - Signor Placeholder Name"
                                             v-model="form.template_signor_placeholder_name"
                                             placeholder=""
                                             :error-messages="form.errors.template_signor_placeholder_name"
                                         ></v-text-field-v1>
                                     </div>
                                 </v-col>
                                 <v-col cols="12">
                                     <div>
                                         <v-text-field-v1
                                             label="Signwell - Requester Email"
                                             v-model="form.template_requester_email"
                                             placeholder=""
                                             :error-messages="form.errors.template_requester_email"
                                         ></v-text-field-v1>
                                     </div>
                                 </v-col>
                                 <v-col cols="12">
                                     <div>
                                         <v-text-field-v1
                                             label="Signwell - Company Sign Date Field"
                                             v-model="form.template_sign_date_field"
                                             placeholder=""
                                             :error-messages="form.errors.template_sign_date_field"
                                         ></v-text-field-v1>
                                     </div>
                                 </v-col>
                             </v-row>
                         </div>
                         <div class="border rounded-lg pa-4">
                             <div class="d-flex flex-column ga-4">
                                <div class="fw-medium fs-1">Template Variables:</div>
                                <div class="well fs-1" v-if="Object.keys(form.template_variables).length">
                                    <div class="d-flex flex-wrap align-center ga-4" v-for="(value, key) in form.template_variables">
                                        <div>
                                            <span class="fw-medium">{{ value.label }}</span>: {{ key }} 
                                            <span class="text-secondary" v-if="value.map && value.map !== 'user_input'">(Mapped: <span class="fw-medium">{{page.props.data?.template_variable_map?.[value.map]?.name ?? value.map}}</span>)</span>
                                        </div>
                                        <div>
                                            <v-btn-icon-text type="button" color="secondary" density="compact" @click.prevent="() => {deleteTemplateVariable(key as string)}">
                                                <mdi-icon size="n4">delete</mdi-icon>
                                            </v-btn-icon-text>
                                        </div>
                                    </div>
                                </div>
                                <div class="">
                                    <v-row class="grid-gap grid-gap-4">
                                                
                                        <v-col cols="12">
                                            <div>
                                                <v-text-field-v1
                                                    density="compact"
                                                    label="Label"
                                                    v-model="templateVariableLabel"
                                                    @keydown.enter="addTemplateVariable"
                                                ></v-text-field-v1>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-select-v1
                                                density="compact"
                                                label="Map"
                                                v-model="templateVariableMap"
                                                :items="Object.values(page.props.data?.template_variable_map ?? {})"
                                                item-value="key"
                                                item-title="name"
                                            ></v-select-v1>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <div class="d-flex">
                                                <div class="flex-grow-1">
                                                    <v-text-field-v1
                                                        density="compact"
                                                        label="Variable"
                                                        v-model="templateVariableKey"
                                                        @keydown.enter="addTemplateVariable"
                                                    ></v-text-field-v1>
                                                </div>
                                                <div class="flex-none ps-3">
                                                    <v-btn type="button" slim density="default" class="match-input-compact" color="primary" @click.prevent="addTemplateVariable" :disabled="!templateVariableLabel || !templateVariableKey">
                                                        <mdi-icon>add</mdi-icon> <span class="text-none fs-n3">Add</span>
                                                    </v-btn>
                                                </div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    
                                </div>
                             </div>
                             <div class="d-flex flex-column ga-7">
                                
                             </div>
                         </div>
                         <div v-if="form.errors.custom_error" class="fs-1 pb-2 text-error">
                             {{ form.errors.custom_error }}
                         </div>
                     </div>
                 </v-card-text>
                 <v-card-actions-form>
                     <div class="d-flex flex-grow-1 justify-space-between">
                         <v-btn-input-compact color="btn-secondary" @click="helpers.goBack">
                             <template #prepend>
                                 <mdi-icon>chevron_left</mdi-icon>
                             </template>
                             Back
                         </v-btn-input-compact>
                         <v-btn-input-compact type="submit" :disabled="form.processing" :loading="form.processing">
                             <template #prepend>
                                 <mdi-icon>check</mdi-icon>
                             </template>
                             Save
                         </v-btn-input-compact>
                     </div>
                     
                 </v-card-actions-form>
             </v-card>
         </v-form>
     </div>
 </template>
 <script setup lang="ts">
     import { ref } from "vue";
     import { useForm, usePage, router } from '@inertiajs/vue3';
     import { toast } from 'vue3-toastify';
     import { SharedPage, SharedPageProps } from '@/Types/inertia';
     import { User } from '@/Types/Models/user';
     import helpers from '@/Plugins/helpers';
     import { pageTitle, containerGapForForm } from '@/Composables/PageMeta';
     import { Biller, TemplateVariable } from "@/Types/Models/biller";
     import { useDate } from 'vuetify';
     import { useAuth } from '@/Composables/Auth';

     import defaultLogo from './../../../assets/images/image-placeholder.svg';
     
 
     pageTitle.value = 'Add Biller';
     containerGapForForm();
     interface PageData extends SharedPageProps{
         data?:{
             biller?: Biller,
             template_variable_map?: {[key: string]: {
                key: string,
                name: string,
             }}
             success_redirect?: string
         }
     }

 
     interface Form extends Biller{
         custom_error: string,
         success_redirect: string,
         logo_file: File | null,
         template_signor_placeholder_id: string,
         template_signor_placeholder_name: string,
         template_requester_email: string,
         template_sign_date_field: string,
         template_variables: TemplateVariable,
     }
 
     const page = usePage<PageData>();
     const biller = ref<Biller>(page.props.data?.biller ?? {} as Biller);
     const formRef = ref<HTMLFormElement | null>(null);
     const formValid = ref<boolean | null>(false);
     const form = useForm<Form>({
         custom_error: '',
         name: biller.value?.name ?? '',
         email: biller.value?.email ?? '',
         domain: biller.value?.domain ?? '',
         street_address: biller.value?.street_address ?? '',
         city: biller.value?.city ?? '',
         state: biller.value?.state ?? '',
         postal_code: biller.value?.postal_code ?? '',
         country: biller.value?.country ?? '',
         signwell_template_id: biller.value?.signwell_template_id ?? '',
         template_signor_placeholder_id: biller.value?.additional_data?.template_signor_placeholder_id ?? '',
         template_signor_placeholder_name: biller.value?.additional_data?.template_signor_placeholder_name ?? '',
         template_requester_email: biller.value?.additional_data?.template_requester_email ?? '',
         template_sign_date_field: biller.value?.additional_data?.template_sign_date_field ?? '',
         template_variables: !Object.keys(biller.value?.additional_data?.template_variables ?? {}).length ? {} : biller.value?.additional_data?.template_variables,
         logo_file: null,
 
         success_redirect: page.props.data?.success_redirect ?? '',
     });

     const templateVariableKey = ref('');
     const templateVariableLabel = ref('');
     const templateVariableMap = ref(null);

     const addTemplateVariable = (event: Event) => {
        event.preventDefault();
        let key = templateVariableKey.value.trim();
        let label = templateVariableLabel.value.trim();
        let map = (templateVariableMap.value ?? '').trim();
        if(!map){
            map = 'user_input';
        }
        if(key && label){
            form.template_variables[key] = {
                label: label,
                map: map,
            };
            templateVariableKey.value = '';
            templateVariableLabel.value = '';
            templateVariableMap.value = null;
        }
        
     }

     const deleteTemplateVariable = (key: string) => {
        delete form.template_variables[key];
     }

     const logoPreview = ref<string | null>(null);
    const logoInput = ref<HTMLInputElement | null>(null);
    const updateLogoPreview = () => {
        const logo = logoInput.value?.files?.[0];

        if (! logo) return;

        const reader = new FileReader();

        reader.onload = (e: ProgressEvent<FileReader>) => {
            logoPreview.value = e.target?.result as string;
        };

        reader.readAsDataURL(logo);
    };
    const selectNewLogo = () => {
        if(logoInput.value){
            logoInput.value.click();
        }
    };
    const clearLogoFileInput = () => {
        if (logoInput.value?.value) {
            logoInput.value.value = '';
        }
    };
    const deleteLogo = () => {
        router.delete(route('brand.deleteLogo'), {
            preserveScroll: true,
            onSuccess: () => {
                logoPreview.value = null;
                clearLogoFileInput();
            },
        });
    };

 
     const store = async () => {
         console.log(form);
         if (logoInput.value) {
            form.logo_file = logoInput.value?.files?.[0] ?? null;
        }
         var validated = await formRef.value?.validate();
         console.log(validated, formValid.value);
         if(validated?.valid){
             form.post(route('billers.store', biller.value?.id ?? 0), {
                 preserveState: true,
                 onSuccess: (page: SharedPage) => {
                     toast.success(page.props?.jetstream?.flash?.msg?.text ?? 'Biller is saved');
                     formRef.value?.resetValidation();
                     form.clearErrors();
                 },
                 onFinish: (visit) => {
                     // console.log('visit onFinish', visit);
                 },
                 onError: (errors) => {
                     console.log('onError', errors);
                     formRef.value?.resetValidation();
                 }
             });
         }
         else{
             form.setError('custom_error', 'There are invalid data in the form, please check once again');
         }
     }
 </script>